import copy from "../../../copy/en/admin-workspace.json" with { type: "json" };
import { Link, Outlet, useLocation } from "react-router";
import { useMe } from "../../auth/MeProvider.js";
import { adminGroups, adminSectionActive } from "./adminNavigation.js";
import "./adminWorkspace.css";
export * from "./adminNavigation.js";

export function AdminLayout() {
  const { me, hasCap } = useMe();
  const { pathname, search } = useLocation();
  const canManage = hasCap("users:manage");
  const canOrg = hasCap("org:manage");
  const groups = adminGroups({ canManage, canOrg, canZoom: me?.role === "admin" && hasCap("integrations:manage") && hasCap("reps:read") });
  const active = groups.find(group => group.sections.some(section => adminSectionActive(section, pathname, search))) ?? groups[0];
  return (
    <section className="admin-workspace">
      <header className="admin-workspace__heading"><h1>{copy.title}</h1></header>
      <nav className="admin-workspace__groups" aria-label={copy.groupsLabel}>
        {groups.map(group => <Link key={group.id} to={group.sections[0]!.to}
          aria-current={active?.id === group.id ? "location" : undefined}
          className={active?.id === group.id ? "is-active" : undefined}>{group.label}</Link>)}
      </nav>
      {active ? <nav className="admin-workspace__sections" aria-label={copy.sectionsLabel}>
        {active.sections.map(section => <Link key={section.to} to={section.to}
          aria-current={adminSectionActive(section, pathname, search) ? "page" : undefined}
          className={adminSectionActive(section, pathname, search) ? "is-active" : undefined}>{section.label}</Link>)}
      </nav> : null}
      <div className="admin-workspace__content"><Outlet /></div>
    </section>
  );
}
